<!--
component: ListKaihatsuResult
author: Ken Nakamura
description: 開発・造成・土石の堆積 番号検索結果リスト
             旧：開発・宅造
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="kaihatsu"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer
      :single-select="true" item-key="id"
      class="elevation-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{item.kyokaNo}}</td>
            <td>{{item.kuName}}</td>
            <td>{{dateTextToWareki(item.kyokaDay)}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      loading: false,
      headers: [
        {
          text: '許可番号',
          value: 'kyokaNo'
        },
        {
          text: '区名',
          value: 'kuName'
        },
        {
          text: '許可日',
          value: 'kyokaDay'
        },
      ],
    }
  },
  props: {
  },
  computed: {
    kaihatsu () {
      return this.$store.state.summaries;
    },
  },
  methods: {
    /**
     * 日付の和暦表示
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },   
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListKaihatsuResult.selectRow(${target.id})`);
      this.$store.commit('setGaiyoId', target.id);
      this.$store.commit('setUkeNo', target.kyokaNo);
      this.kaihatsu.forEach((k) => {
        k.active = (k === target);
      });
    },
  },
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>